import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var EyeClose = function (props) {
  return React__default.createElement("svg", __assign({
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M2.805 1.862 1.862 2.805 3.384 4.327C1.467 5.892 0.667 8 0.667 8s2 5.333 7.333 5.333c1.384 0 2.537 -0.363 3.495 -0.896l1.701 1.701 0.943 -0.943zM8 2.667c-0.808 0 -1.529 0.133 -2.189 0.341l1.707 1.707C7.676 4.691 7.835 4.667 8 4.667a3.333 3.333 0 0 1 3.333 3.333c0 0.165 -0.025 0.324 -0.048 0.482l2.287 2.287C14.802 9.401 15.333 8 15.333 8s-2 -5.333 -7.333 -5.333M5.223 6.165l0.975 0.975C6.072 7.4 6 7.691 6 8a2 2 0 0 0 2 2c0.309 0 0.6 -0.072 0.86 -0.198l0.975 0.975A3.307 3.307 0 0 1 8 11.333a3.333 3.333 0 0 1 -3.333 -3.333c0 -0.68 0.207 -1.308 0.556 -1.835",
    fill: "currentColor"
  }));
};
export { EyeClose as default };
//# sourceMappingURL=EyeClose.js.map
